import { useState } from "react";
import type { GearItem } from "../../../api/client";
import { importCsv, type CsvRow } from "../../../lib/csv";
import { roundTo, unitById } from "../../../lib/units";

/** Pick a CSV, preview the rows in a grid, import them into the library. */
export function ImportCsvView({ onCancel, onImport }: { onCancel: () => void; onImport: (rows: Partial<GearItem>[]) => void }) {
  const [rows, setRows] = useState<CsvRow[]>([]);
  const [error, setError] = useState("");

  async function onFile(e: React.ChangeEvent<HTMLInputElement>) {
    const file = e.target.files?.[0];
    if (!file) return;
    const text = await file.text();
    const parsed = importCsv(text);
    setRows(parsed);
    setError(parsed.length ? "" : "No gear found in that file. Expected columns: name, description, url, category, weight, unit, worn, consumable.");
  }

  return (
    <div className="ImportCsvView shown" role="dialog" aria-label="Import CSV">
      <div className="model">
        <div className="heading">Import CSV</div>
        <div className="content">
          <div className="frame1">
            <input type="file" accept=".csv,text/csv" aria-label="CSV file" onChange={onFile} />
            <a href="#cancel" className="osx_button" onClick={(e) => (e.preventDefault(), onCancel())}>
              Cancel
            </a>
            <hr />
            {error && <p style={{ padding: 10, fontSize: 12 }}>{error}</p>}
            {rows.length > 0 && (
              <div>
                <div className="itemContent">
                  <table className="DataGrid">
                    <thead>
                      <tr>
                        <th>Name</th>
                        <th>Description</th>
                        <th>Category</th>
                        <th>Weight</th>
                      </tr>
                    </thead>
                    <tbody>
                      {rows.map((r, i) => (
                        <tr key={i}>
                          <td>
                            <div>{r.name}</div>
                          </td>
                          <td>
                            <div>{r.description}</div>
                          </td>
                          <td>
                            <div>{r.category}</div>
                          </td>
                          <td>
                            <div>
                              {roundTo(r.grams / unitById(r.unit_id).grams, 2)}
                              {unitById(r.unit_id).abbreviation}
                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
                <hr />
                <a
                  href="#import"
                  className="osx_button"
                  onClick={(e) => {
                    e.preventDefault();
                    onImport(rows.map((r) => ({ name: r.name, description: r.description, url: r.url, category: r.category, grams: r.grams, unit_id: r.unit_id, worn: r.worn, consumable: r.consumable })));
                  }}
                >
                  Import Items
                </a>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
